import ProjectsAssessments from './ProjectsAssessments';

export default ProjectsAssessments;
